(function () {
  function inyectarEstilos() {
    if (document.getElementById('info-envios-estilos')) return;
    var css = [
      '@media (min-width: 990px){',
      '.product-info-envios .product-info-envios__fila-titulo{font-size:var(--info-envios-tt-desktop,17px) !important;}',
      '.product-info-envios .product-info-envios__fila-texto{font-size:var(--info-envios-tx-desktop,15px) !important;}',
      '}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'info-envios-estilos';
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }

  function init() {
    inyectarEstilos();

    var lang = document.documentElement.getAttribute('lang') || 'es';

    function formatearDia(fecha) {
      try {
        return fecha.toLocaleDateString(lang, { day: 'numeric' });
      } catch (e) {
        return String(fecha.getDate());
      }
    }
    function formatearDiaMes(fecha) {
      try {
        return fecha.toLocaleDateString(lang, { day: 'numeric', month: 'long' });
      } catch (e) {
        return String(fecha.getDate());
      }
    }
    function sumarDias(base, dias) {
      var d = new Date(base.getTime());
      d.setDate(d.getDate() + dias);
      return d;
    }

    var nodos = document.querySelectorAll('[data-info-envios-fecha]');
    for (var i = 0; i < nodos.length; i++) {
      var nodo = nodos[i];
      if (nodo.getAttribute('data-info-envios-done') === '1') continue;

      var dmin = parseInt(nodo.getAttribute('data-dmin'), 10);
      var dmax = parseInt(nodo.getAttribute('data-dmax'), 10);
      var plantilla = nodo.getAttribute('data-plantilla') || '';
      if (isNaN(dmin)) dmin = 1;
      if (isNaN(dmax)) dmax = dmin;

      var hoy = new Date();
      var fechaMin = sumarDias(hoy, dmin);
      var fechaMax = sumarDias(hoy, dmax);

      var rango;
      if (dmin === dmax) {
        rango = formatearDiaMes(fechaMax);
      } else if (fechaMin.getMonth() === fechaMax.getMonth()) {
        rango = formatearDia(fechaMin) + ' – ' + formatearDiaMes(fechaMax);
      } else {
        rango = formatearDiaMes(fechaMin) + ' – ' + formatearDiaMes(fechaMax);
      }

      if (plantilla.indexOf('{fecha}') !== -1) {
        nodo.textContent = plantilla.replace('{fecha}', rango);
      } else if (plantilla) {
        nodo.textContent = plantilla + ' ' + rango;
      } else {
        nodo.textContent = rango;
      }
      nodo.setAttribute('data-info-envios-done', '1');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
